import { AlertTriangle } from "lucide-react"
import { Alert } from "../../ui"
import { formatVND } from "../../constants"

// Snapshot of the last submit — BE let it through, approvers need to see why.
const OverBudgetBanner = ({ order }) => {
  if (!order?.overBudget) return null
  return (
    <Alert tone="warn" icon={<AlertTriangle aria-hidden />} title="Order vượt ngân sách">
      Vượt ngân sách{order.overBudgetAmount != null ? ` ${formatVND(order.overBudgetAmount)}` : ""} tại thời điểm
      submit. Xem lý do ở Note / Link to Ticket của từng line và tài liệu đính kèm bên dưới.
    </Alert>
  )
}

export default OverBudgetBanner
